import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faXTwitter, faInstagram, faApple, faGoogle, faSquareFacebook, faSquareInstagram, faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faMemoCircleCheck as falMemoCircleCheck, faArrowRightFromBracket as falArrowRightFromBracket, faLocationArrow as falLocationArrow } from '@fortawesome/sharp-light-svg-icons';
import {
    faCalendarPlus as fasrCalendarPlus,
    faUser as fasrUser,
    faExclamationCircle as fasrExclamationCircle,
    faCircle as fasrCircle,
    faClock as fasrClock,
    faEllipsisVertical as fasrEllipsisVertical,
    faPhoneVolume as fasrPhoneVolume,
} from '@fortawesome/sharp-regular-svg-icons';
import {
    faExclamationTriangle as fasExclamationTriangle,
    faCheck as fassCheck,
    faHouse as fassHouse,
    faLocationDot as fassLocationDot,
    faScrewdriverWrench as fassScrewdriverWrench,
    faClock as fassClock,
    faPen as fassPen,
    faCalendarDays as fassCalendarDays,
    faMagnifyingGlass as fassMagnifyingGlass,
    faQuestion as fassQuestion,
    faAmbulance as fassAmbulance,
    faX as fassX,
    faThumbsUp as fassThumbsUp,
    faCheck as fasCheck,
    faXmark as fasXMark,
    faLoader as fasLoader,
    faChevronRight as fasChevronRight,
    faChevronDown as fasChevronDown,
    faTooth as fasTooth,
    faExclamationCircle as fasExclamationCircle,
    faEnvelope as fasEnvelope,
    faPhone as fasPhone,
    faGlobe as fasGlobe,
    faArrowRightFromBracket as fasArrowRightFromBracket,
    faExclamation as fasExclamation,
    faLightEmergencyOn as fasLightEmergencyOn,
    faChevronLeft as fasChevronLeft,
} from '@fortawesome/sharp-solid-svg-icons';
import {
    faExclamationCircle as fastExclamationCircle,
    faUser as fastUser,
    faTooth as fastTooth,
    faCircle as fastCircle,
    faLocationDot as fastLocationDot,
    faGlobe as fastGlobe,
    faPhone as fastPhone,
    faEnvelope as fastEnvelope,
    faCalendarXmark as fastCalendarXmark,
} from '@fortawesome/sharp-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
    fasExclamation,
    fasChevronRight,
    fasChevronDown,
    fasLoader,
    fasXMark,
    fasCheck,
    fassCalendarDays,
    fasrCalendarPlus,
    faApple,
    faGoogle,
    fassX,
    fassThumbsUp,
    fastUser,
    fassAmbulance,
    fastTooth,
    fassMagnifyingGlass,
    fastLocationDot,
    fassQuestion,
    fassHouse,
    faFacebookF,
    faXTwitter,
    faInstagram,
    fastGlobe,
    fasrUser,
    fassLocationDot,
    fassScrewdriverWrench,
    fassClock,
    fassPen,
    fastCircle,
    fastPhone,
    fastEnvelope,
    fassCheck,
    fastExclamationCircle,
    fasTooth,
    fasEnvelope,
    fasPhone,
    fasGlobe,
    faSquareFacebook,
    faSquareInstagram,
    faSquareXTwitter,
    fasExclamationCircle,
    fasrExclamationCircle,
    fasArrowRightFromBracket,
    fasrCircle,
    fasrClock,
    falMemoCircleCheck,
    fasLightEmergencyOn,
    fasChevronLeft,
    falArrowRightFromBracket,
    fastCalendarXmark,
    fasExclamationTriangle,
    fasrEllipsisVertical,
    fasrPhoneVolume,
    falLocationArrow
);

export default FontAwesomeIcon;
